import React, { useEffect, useRef, useState } from 'react'
import { BASE } from '../../basedata/constants'

import './LoadingHandler.sass'

const LoadingHandlerValidator = () => {


  const verifyBiometry = (token: any) => {


    fetch(`${BASE.user_biometry.base_url}${BASE.user_biometry.document_status}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: BASE.api.token
      },
      body: JSON.stringify({
        "token": token
      })
    })
      .then((resg) => resg.json())
      .then((response) => {
        if (response.message === 'success') {
          if (response.userInformation && response.userInformation?.callbackURL?.length > 0) {
            window.sessionStorage.setItem('callbackurl', response.userInformation.callbackURL)
            // return window.location.href = `${response.userInformation.callbackURL}`
            window.location.reload()

          } else {
            const searchParams = new URLSearchParams(window.location.search);
            searchParams.set('doc', 'false');
            window.location.search = searchParams.toString();
            window.location.reload()
          }
        } else if (response.message === 'errorDoc') {
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.set('doc', 'false');
          window.location.search = searchParams.toString();
          window.location.reload()
        }else {
          setTimeout(() => {
            verifyBiometry(token)
          }, 5000);
        }

      })
      .catch((error) => {
        return setTimeout(() => {
          verifyBiometry(token)
        }, 5000);
        
      })

  }

  const initialized = useRef(false)
  useEffect(() => {
    if (!initialized.current) {
    initialized.current = true
    verifyBiometry(window.sessionStorage.getItem('token'))
    }
  }, [])
  
  return (
    <>
    <p className='text-center'>
      Validando seus dados e biometria, podemos levar alguns minutos...
    </p>
    <div className="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    </>
  )
}

export default LoadingHandlerValidator
